var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{attrs:{"id":"modal-search","title":"Search People","busy":true,"return-focus":"body"}},[_c('app-people-search',{attrs:{"action":"navToPerson"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }